import { Menu, MenuItem, Typography } from '@mui/material';
import { LucideIcon } from 'lucide-react';
import { getDropdownMenuPaperSx } from 'src/utils/dropdown-paper';

export interface OptionSwitchMenuOption<OptionId> {
  value: OptionId;
  label: string;
  icon: LucideIcon;
}

interface OptionSwitchMenuProps<OptionId> {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  options: OptionSwitchMenuOption<OptionId>[];
  selectedValue?: OptionId;
  onSelect: (value: OptionId) => void;
}

export const OptionSwitchMenu = <OptionId,>({
  anchorEl,
  onClose,
  options,
  selectedValue,
  onSelect,
}: OptionSwitchMenuProps<OptionId>) => (
  <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    slotProps={{
      paper: {
        sx: (theme) => ({
          ...getDropdownMenuPaperSx(theme),
          minWidth: '12.5rem',
        }),
      },
    }}
  >
    {options.map((option) => {
      const OptionIcon = option.icon;

      return (
        <MenuItem
          selected={option.value === selectedValue}
          key={option.label}
          onClick={() => onSelect(option.value)}
        >
          <OptionIcon size={20} />
          <Typography textAlign="center">{option.label}</Typography>
        </MenuItem>
      );
    })}
  </Menu>
);
